module.exports = __webpack_public_path__ + "img/3.800bc3aa.jpg";